import ParentView from '@/components/ParentView'

const asyncAuthRoutes = {
  path: 'auth',
  component: ParentView,
  funcPerms: 'system:setting:auth',
  name: 'auth',
  meta: {
    title: '权限管理',
    // icon: 'el-icon-s-grid',
    icon: 'index',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'systems/list',
      component: () => import('@/views/system/auth/systems/index'),
      funcPerms: 'system:setting:auth:systems',
      name: 'auth-systems',
      meta: {
        title: '系统模块',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'roles/list',
      component: () => import('@/views/system/auth/roles/index'),
      funcPerms: 'system:setting:auth:roles',
      name: 'auth-roles',
      meta: {
        title: '角色管理',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'func/list',
      component: () => import('@/views/system/auth/menu/index'),
      funcPerms: 'system:setting:auth:menus',
      name: 'auth-func',
      meta: {
        title: '菜单管理',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    }
  ]
}

export default asyncAuthRoutes
